import Button from "./Button";
import { useDispatch } from "react-redux";
import { assistantApplicationsClosed } from "../../store/modal/modalSlice";

const ButtonPair = () => {
  const dispatch = useDispatch();
  const applicationClosed = () => {
    dispatch(assistantApplicationsClosed());
  };
  return (
    <div className="flex flex-col sm:flex-row gap-6 mb-8 lg:mb-0">
      <Button text="Join as a Customer" link="/signup/customer" />
      <div onClick={applicationClosed}>
        <Button
          text="Join as an Assistant"
          // link="/signup/assistant"
          stroke={true}
        />
      </div>
    </div>
  );
};

export default ButtonPair;
